module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./RecordView.js"));
	}, "CouponRecordView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=CouponRecordView!./src/pages/Shop/Member/Wallet/Coupon/Record/RecordView.js
// module id = 1589
// module chunks = 418